import { Injectable } from '@angular/core';
import { ApiRoutes } from '../../../config/api-routes';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/internal/operators';

@Injectable()
export class Accountservice {

    constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) {}

    public setCulture(culture: string): Observable<any> {
        const params = new HttpParams().set('culture', culture);
                return of();
    }
}
